import { BaseTool } from "../BaseTool.js";
import { createStyledDot, isPrimaryPointer } from "../toolHelpers.js";

export class DotTool extends BaseTool {
  constructor() {
    super("dot");
  }

  onPointerDown(context) {
    if (!isPrimaryPointer(context)) {
      return;
    }

    context.clearPreview();
    createStyledDot(context, context.worldPoint);
    context.render();
  }
}
